var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import Box from "../../box/Box";
import { Img } from "../../image";
import Text from "../../text";
import StarRating from "onnit-ui/lib/rating/StarRating";
import PriceLabel from "onnit-ui/lib/buybox/shared/PriceLabel";
import { useAddToBag } from "../../hooks/useAddToBag";
import Button from "../../button/Button";
import { FavoriteContainerButton } from "onnit-ui/lib/buybox/shared/favorites";
var SimpleBuyBox = function (_a) {
    var product = _a.product, productNameTransform = _a.productNameTransform, additionalImgixParams = _a.additionalImgixParams, children = _a.children, rest = __rest(_a, ["product", "productNameTransform", "additionalImgixParams", "children"]);
    var _b = useAddToBag(), isAddingToBag = _b.isAddingToBag, addToBag = _b.addToBag;
    if (!product) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        !product.in_stock && (React.createElement(Box, { display: "flex", justifyContent: "flex-end", mr: 2 },
            React.createElement(Box, { style: { border: '1px solid #353535' }, py: [1], px: [1] },
                React.createElement(Text, { textTransform: "uppercase", fontWeight: "bold", color: "grays.6", fontSize: 0 }, "Out of Stock")))),
        React.createElement(Box, __assign({ display: "flex", flexDirection: "column", height: "100%", style: product.in_stock ? {} : { opacity: 0.65 } }, rest),
            React.createElement(Img, { src: "https://onnits3.imgix.net/authority/".concat(product.meta["authority-id"], ".png?w=704&q=50&fm=pjpg&auto=compress,format&").concat(additionalImgixParams), placeholder: [704, 958], alt: "product image" }),
            React.createElement(Box, { flex: "1", mb: 2 },
                React.createElement(Text, { typeStyle: "text03", as: "p", mb: 2 }, productNameTransform ? productNameTransform(product.name, product.id) : product.name),
                product.blurb && (React.createElement(Text, { typeStyle: "text04", fontWeight: "bold", as: "p", mt: 2, color: "grays.5" }, product.blurb)),
                children),
            React.createElement(Box, { display: "flex", flex: product.in_stock ? "0" : "1" },
                React.createElement(Box, { flex: "1" },
                    product.bazaarvoiceRating && (React.createElement(StarRating, { rating: Number(product.bazaarvoiceRating), mb: 3 })),
                    React.createElement(PriceLabel, { product: product })),
                React.createElement(Box, null,
                    React.createElement(FavoriteContainerButton, { productId: product.id, iconOnly: true, size: "small", width: "initial" }))),
            product.in_stock && (React.createElement(Button, { size: ["small", "small", "medium"], mt: 5, width: 1, display: "block", disabled: isAddingToBag, onClick: function () {
                    var config = {
                        product_id: product.id,
                        quantity: 1,
                        subscription_interval: null,
                    };
                    addToBag(config);
                } }, isAddingToBag ? "Adding..." : "Add to Bag")))));
};
export default SimpleBuyBox;
//# sourceMappingURL=SimpleBuyBox.js.map